import { render, staticRenderFns } from "./DriverInsert.vue?vue&type=template&id=fdfba0d2&scoped=true&"
import script from "./DriverInsert.vue?vue&type=script&lang=js&"
export * from "./DriverInsert.vue?vue&type=script&lang=js&"
import style0 from "./DriverInsert.vue?vue&type=style&index=0&id=fdfba0d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfba0d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCard,VDatePicker,VMenu,VTextField,VTextarea})
